<template>
  <div class="app-container">
    <!-- 面包屑导航 -->
    <!-- 卡片容器 -->
    <el-card class="box-card">
      <!-- 搜索表单和操作按钮区域 -->
      <div class="filter-container">
        <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px" class="filter-form">
          <el-form-item label="商户ID" prop="merchantId">
            <el-input
              v-model="queryParams.merchantId"
              placeholder="请输入商户ID"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="订单类型" prop="orderType">
          <el-select v-model="queryParams.orderType" placeholder="请选择订单类型" clearable size="small">
            <el-option
              v-for="dict in orderTypeDict"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="isActive">
          <el-select v-model="queryParams.isActive" placeholder="请选择是否启用" clearable size="small">
            <el-option
              v-for="dict in sysYesNoDict"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            />
          </el-select>
        </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery" style="background-color: #3CA757; border-color: #3CA757;">搜索</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
        
        <div class="btn-container">
          <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
            v-hasPermi="['distributor:orderSplitConfig:add']"
            style="background-color: #3CA757; border-color: #3CA757; color: #fff;"
          >新增</el-button>
          <el-button
            type="success"
            plain
            icon="el-icon-edit"
            size="mini"
            :disabled="single"
            @click="handleUpdate"
            v-hasPermi="['distributor:orderSplitConfig:edit']"
            style="background-color: #3CA757; border-color: #3CA757; color: #fff;"
          >修改</el-button>
          <el-button
            type="danger"
            plain
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['distributor:orderSplitConfig:remove']"
          >删除</el-button>
          <el-button
            type="warning"
            plain
            icon="el-icon-download"
            size="mini"
            @click="handleExport"
            v-hasPermi="['distributor:orderSplitConfig:export']"
            style="background-color: #3CA757; border-color: #3CA757; color: #fff;"
          >导出</el-button>
          <el-button
            type="text"
            size="mini"
            :icon="showSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            @click="showSearch = !showSearch"
            style="color: #3CA757;"
          >{{ showSearch ? '隐藏搜索' : '显示搜索' }}</el-button>
        </div>
      </div>

      <el-table v-loading="loading" :data="orderSplitConfigList" @selection-change="handleSelectionChange" stripe>
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="序号" type="index" width="60" align="center" />
        <el-table-column label="配置ID" align="center" prop="id" />
        <el-table-column label="商户ID" align="center" prop="merchantId" />
        <el-table-column label="订单类型" align="center" prop="orderType">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.orderType === '1' ? '#67C23A' : '#E6A23C' }">{{ getDictLabel(orderTypeDict, scope.row.orderType) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="规则ID" align="center" prop="ruleId" />
        <el-table-column label="规则名称" align="center" prop="ruleName" />
        <el-table-column label="是否启用" align="center" prop="isActive">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.isActive === 'Y' ? '#67C23A' : '#F56C6C' }">{{ getDictLabel(sysYesNoDict, scope.row.isActive) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="250">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-view"
              @click="handleDetail(scope.row)"
              v-hasPermi="['distributor:orderSplitConfig:query']"
            >详情</el-button>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
              v-hasPermi="['distributor:orderSplitConfig:edit']"
            >修改</el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              v-hasPermi="['distributor:orderSplitConfig:delete']"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页区域 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParams.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加或修改订单分账配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body @close="handleDialogClose">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="商户ID" prop="merchantId">
          <el-input v-model="form.merchantId" placeholder="请输入商户ID" />
        </el-form-item>
        <el-form-item label="订单类型" prop="orderType">
          <el-select v-model="form.orderType" placeholder="请选择订单类型">
            <el-option
              v-for="dict in orderTypeDict"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规则ID" prop="ruleId">
          <el-input v-model="form.ruleId" placeholder="请输入规则ID" />
        </el-form-item>
        <el-form-item label="是否启用" prop="isActive">
          <el-radio-group v-model="form.isActive">
            <el-radio
              v-for="dict in sysYesNoDict"
              :key="dict.value"
              :label="dict.value"
            >{{dict.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" placeholder="请输入内容" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" style="background-color: #3CA757; border-color: #3CA757;">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 订单分账配置详情对话框 -->
    <el-dialog title="订单分账配置详情" :visible.sync="detailOpen" width="700px" append-to-body>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="配置ID">{{ detailForm.id }}</el-descriptions-item>
        <el-descriptions-item label="商户ID">{{ detailForm.merchantId }}</el-descriptions-item>
        <el-descriptions-item label="订单类型">
          <span :style="{ color: detailForm.orderType === '1' ? '#67C23A' : '#E6A23C' }">{{ getDictLabel(orderTypeDict, detailForm.orderType) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="规则ID">{{ detailForm.ruleId }}</el-descriptions-item>
        <el-descriptions-item label="规则名称">{{ detailForm.ruleName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="是否启用">
          <span :style="{ color: detailForm.isActive === 'Y' ? '#67C23A' : '#F56C6C' }">{{ getDictLabel(sysYesNoDict, detailForm.isActive) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detailForm.createTime }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ detailForm.updateTime }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detailForm.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailOpen = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OrderSplitConfigManage",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 订单分账配置表格数据
      orderSplitConfigList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示详情弹出层
      detailOpen: false,
      // 查询参数
      queryParams: {
        page: 1,
        limit: 10,
        merchantId: null,
        orderType: null,
        isActive: null,
      },
      // 表单参数
      form: {},
      // 详情表单参数
      detailForm: {},
      // 表单校验
      rules: {
        merchantId: [
          { required: true, message: "商户ID不能为空", trigger: "blur" }
        ],
        orderType: [
          { required: true, message: "订单类型不能为空", trigger: "change" }
        ],
        ruleId: [
          { required: true, message: "规则ID不能为空", trigger: "blur" }
        ],
        isActive: [
          { required: true, message: "是否启用不能为空", trigger: "change" }
        ]
      },
      // 静态字典数据
      orderTypeDict: [
        { label: '普通订单', value: '1' },
        { label: '分账订单', value: '2' }
      ],
      sysYesNoDict: [
        { label: '是', value: 'Y' },
        { label: '否', value: 'N' }
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询订单分账配置列表 */
    getList() {
      this.loading = true;
      this.$http.get('/order/split/config/list', {
        params: this.queryParams
      }).then(response => {
        if (response.data.code === 200) {
          this.orderSplitConfigList = response.data.rows;
          this.total = response.data.total;
        } else {
          this.$message.error(response.data.msg || '获取数据失败');
        }
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.$message.error('获取数据失败');
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        merchantId: null,
        orderType: null,
        ruleId: null,
        isActive: "Y",
        remark: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加订单分账配置";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids;
      this.$http.get('/order/split/config/' + id).then(response => {
        if (response.data.code === 200) {
          this.form = response.data.data;
          this.open = true;
          this.title = "修改订单分账配置";
        } else {
          this.$message.error(response.data.msg || '获取数据失败');
        }
      }).catch(error => {
        this.$message.error('获取数据失败');
      });
    },
    /** 详情按钮操作 */
    handleDetail(row) {
      this.detailForm = row;
      this.detailOpen = true;
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            this.$http.put('/order/split/config/' + this.form.id, this.form).then(response => {
              if (response.data.code === 200) {
                this.$modal.msgSuccess("修改成功");
                this.open = false;
                this.getList();
              } else {
                this.$message.error(response.data.msg || '修改失败');
              }
            }).catch(error => {
              this.$message.error('修改失败');
            });
          } else {
            this.$http.post('/order/split/config', this.form).then(response => {
              if (response.data.code === 200) {
                this.$modal.msgSuccess("新增成功");
                this.open = false;
                this.getList();
              } else {
                this.$message.error(response.data.msg || '新增失败');
              }
            }).catch(error => {
              this.$message.error('新增失败');
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除订单分账配置编号为"' + ids + '"的数据项？').then(() => {
        this.$http.delete('/order/split/config/' + ids).then(response => {
          if (response.data.code === 200) {
            this.$modal.msgSuccess("删除成功");
            this.getList();
          } else {
            this.$message.error(response.data.msg || '删除失败');
          }
        }).catch(error => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    
    /** 根据字典值获取标签 */
    getDictLabel(dictList, value) {
      const dict = dictList.find(item => item.value === value);
      return dict ? dict.label : value;
    },
    /** 导出按钮操作 */
    handleExport() {
      this.$http.get('/order/split/config/export', {
        params: this.queryParams,
        responseType: 'blob'
      }).then(response => {
        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `orderSplitConfig_${new Date().getTime()}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(downloadUrl);
      }).catch(error => {
        this.$message.error('导出失败');
      });
    },
    // 分页事件处理
    handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    // 对话框关闭事件处理
    handleDialogClose() {
      this.reset();
    }
  }
};
</script>
<style scoped>
.breadcrumb {
  margin-bottom: 20px;
}
.box-card {
  margin-bottom: 20px;
}
.filter-container {
  padding-bottom: 10px;
}
.filter-container .filter-item {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 10px;
  margin-right: 10px;
}
.btn-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>